export default String.raw`
const validationPopupUI = (() => {
    'use strict';
    // Function that maps results to proper DOM structure
    const mapResults = (results) => {
                const mappedResults = results.map(result => {
            return {
                Name: result.Object?.NameNoHtml || '',
                Type: result?.Type || '',
                Message: result?.Message || '',
                Error: result.Validation?.[0]?.Error || '',
                Description: result?.Description || '',
                Code: result?.Code || ''
            };
        });
        // We can group by error Code ...
        //const groupedResults = Object.groupBy(mappedResults, result => result.Code);

        return mappedResults;
    };

    const getResultTemplate = (result) => {
        let template = '<li class="products__list-item">';
        if (result.Name) {
            template += '<p class="product__name">' + result.Name + '</p>';
        }
        if (result.Message) {
            template += '<p class="product__message">' + result.Message + '</p>';
        }
        if (result.Description) {
            template += '<p class="product__description">' + result.Description + '</p>';
        }
        if (result.Error) {
            template += '<p class="product_error">' + result.Error + '</p>';
        }
        template += '</li>';
        return template;
    };

    window.addEventListener('validation:failure', (e) => {
        const results = e.detail.results;
        let customTitle = e.detail.title;

        const popup = document.querySelector('.validation-popup-js');
    
        if (!popup) {
            return;
        }

        if(!customTitle) {
            customTitle = $('.validation-popup-js .validation-title-js').data('default-title');
        }
    
        const items = mapResults(results).map(getResultTemplate).join('');
        
        $('.validation-popup-js .validation-title-js').text(customTitle);
        $('.validation-popup-js .products-js').html(items);

        popup.showModal();
    });
})();
`